export default class NoRoadbookError extends Error {
  constructor(e = 'Aucune feuille de route') {
    super(e)
    this.name = 'NoRoadbookError'
  }
}
